module.exports = __webpack_public_path__ + "static/media/meetingRoomSelected.176b0b00.png";